<template>
    <img :name="k" class="image-view" :src="'/img/' + t(k)"/>
</template>

<script>
    export default {
        name: "TextView",
        props: {
            k: String,
        }
    }
</script>

<style>
    .image-view {

    }
</style>
